"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingAnchorWrapTightDestination = exports.DrawingAnchorWrapThroughDestination = exports.DrawingAnchorWrapSquareDestination = exports.DrawingAnchorPolygonDestinationBase = exports.DrawingAnchorWrapTopAndBottomDestination = exports.DrawingAnchorWrapNoneDestination = void 0;
var tslib_1 = require("tslib");
var enums_1 = require("../../../../core/model/floating-objects/enums");
var string_1 = require("@devexpress/utils/lib/utils/string");
var translation_tables_1 = require("../../../translation-table/translation-tables");
var destination_1 = require("../destination");
var DrawingAnchorWrapNoneDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorWrapNoneDestination, _super);
    function DrawingAnchorWrapNoneDestination(data, anchorDestination) {
        var _this = _super.call(this, data) || this;
        _this.anchorDestination = anchorDestination;
        return _this;
    }
    DrawingAnchorWrapNoneDestination.prototype.processElementOpen = function (_reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.anchorDestination.floatingObject.wrapType = enums_1.AnchorObjectTextWrapType.None;
                return [2];
            });
        });
    };
    return DrawingAnchorWrapNoneDestination;
}(destination_1.LeafElementDestination));
exports.DrawingAnchorWrapNoneDestination = DrawingAnchorWrapNoneDestination;
var DrawingAnchorWrapTopAndBottomDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorWrapTopAndBottomDestination, _super);
    function DrawingAnchorWrapTopAndBottomDestination(data, anchorDestination) {
        var _this = _super.call(this, data) || this;
        _this.anchorDestination = anchorDestination;
        return _this;
    }
    DrawingAnchorWrapTopAndBottomDestination.prototype.processElementOpen = function (_reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.anchorDestination.floatingObject.wrapType = enums_1.AnchorObjectTextWrapType.TopAndBottom;
                return [2];
            });
        });
    };
    return DrawingAnchorWrapTopAndBottomDestination;
}(destination_1.LeafElementDestination));
exports.DrawingAnchorWrapTopAndBottomDestination = DrawingAnchorWrapTopAndBottomDestination;
var DrawingAnchorPolygonDestinationBase = (function (_super) {
    tslib_1.__extends(DrawingAnchorPolygonDestinationBase, _super);
    function DrawingAnchorPolygonDestinationBase(data, anchorDestination) {
        var _this = _super.call(this, data) || this;
        _this.anchorDestination = anchorDestination;
        return _this;
    }
    DrawingAnchorPolygonDestinationBase.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var value;
            return tslib_1.__generator(this, function (_a) {
                value = reader.getAttribute('wrapText');
                if (!string_1.StringUtils.isNullOrEmpty(value)) {
                    this.anchorDestination.floatingObject.wrapSide = this.data.readerHelper.getWpEnumValueCore(value, translation_tables_1.TranslationTables.floatingObjectTextWrapSideTable.importMap, enums_1.AnchorObjectTextWrapSide.Both);
                }
                return [2];
            });
        });
    };
    return DrawingAnchorPolygonDestinationBase;
}(destination_1.LeafElementDestination));
exports.DrawingAnchorPolygonDestinationBase = DrawingAnchorPolygonDestinationBase;
var DrawingAnchorWrapSquareDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorWrapSquareDestination, _super);
    function DrawingAnchorWrapSquareDestination(data, anchorDestination) {
        return _super.call(this, data, anchorDestination) || this;
    }
    DrawingAnchorWrapSquareDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                _super.prototype.processElementOpen.call(this, reader);
                this.anchorDestination.floatingObject.wrapType = enums_1.AnchorObjectTextWrapType.Square;
                return [2];
            });
        });
    };
    return DrawingAnchorWrapSquareDestination;
}(DrawingAnchorPolygonDestinationBase));
exports.DrawingAnchorWrapSquareDestination = DrawingAnchorWrapSquareDestination;
var DrawingAnchorWrapThroughDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorWrapThroughDestination, _super);
    function DrawingAnchorWrapThroughDestination(data, anchorDestination) {
        return _super.call(this, data, anchorDestination) || this;
    }
    DrawingAnchorWrapThroughDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                _super.prototype.processElementOpen.call(this, reader);
                this.anchorDestination.floatingObject.wrapType = enums_1.AnchorObjectTextWrapType.Through;
                return [2];
            });
        });
    };
    return DrawingAnchorWrapThroughDestination;
}(DrawingAnchorPolygonDestinationBase));
exports.DrawingAnchorWrapThroughDestination = DrawingAnchorWrapThroughDestination;
var DrawingAnchorWrapTightDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorWrapTightDestination, _super);
    function DrawingAnchorWrapTightDestination(data, anchorDestination) {
        return _super.call(this, data, anchorDestination) || this;
    }
    DrawingAnchorWrapTightDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                _super.prototype.processElementOpen.call(this, reader);
                this.anchorDestination.floatingObject.wrapType = enums_1.AnchorObjectTextWrapType.Tight;
                return [2];
            });
        });
    };
    return DrawingAnchorWrapTightDestination;
}(DrawingAnchorPolygonDestinationBase));
exports.DrawingAnchorWrapTightDestination = DrawingAnchorWrapTightDestination;
